import {Component, EventEmitter, inject, Input, OnChanges, OnInit, Output} from '@angular/core';
import {PostModel} from 'src/app/models/post.model';
import {GlobalService} from 'src/app/services/global/global.service';
import {UserService} from 'src/app/services/user/user.service';
import {ApiResponse} from 'src/app/services/utils';
import {CompanyService} from '../../services/company/company.service';
import {ModalController} from "@ionic/angular";

@Component({
    selector: 'app-common-my-ap',
    templateUrl: './common-my-ap.component.html',
    styleUrls: ['./common-my-ap.component.scss'],
    standalone: false
})
export class CommonMyApComponent implements OnInit, OnChanges {

  @Input() companyId;
  @Input() teamId;
  @Input() type;
  @Input() search: string = '';
  @Input() onlyCompany;

  @Output() impactScoreChangedonComponent: EventEmitter<number> = new EventEmitter();
  @Output() closed = new EventEmitter<void>();

  myAPResponseFlag = false;
  pageMyAP = 1;
  myAP: PostModel[];
  loading = false;
  maxAPLoaded: boolean = false;

  searchEnabled = false;

  private modalCtrl: ModalController = inject(ModalController);

  constructor(
    private userService: UserService,
    private globalService: GlobalService,
    private companyService: CompanyService
  ) {

  }

  ngOnInit() {
    this.pageMyAP = 1;
    this.loadMyActionPoints();

    this.globalService.companyMyAPEvent.subscribe(val => {
      if (val !== 0) {
        this.pageMyAP = 1;
        this.loadMyActionPoints();
      }
    });

    this.globalService.teamMyAPEvent.subscribe(val => {
      if (val !== 0) {
        this.pageMyAP = 1;
        this.loadMyActionPoints();
      }
    });
  }

  ngOnChanges(): void {
    this.getSearch();
  }

  pageIncrement() {
    this.loadMyActionPoints();
  }

  searchIncrement() {
    this.loadSearch();
  }

  reloadMyAP() {
    this.pageMyAP = 1;
    this.loadMyActionPoints();
  }

  impactScoreIncreaseDecrease(score: any) {
    this.impactScoreChangedonComponent.emit(score);
  }

  loadMyActionPoints() {
    if (this.myAPResponseFlag === false && !this.maxAPLoaded) {
      this.myAPResponseFlag = true;
      this.loading = true;
      if (this.onlyCompany === 'yes') {
        this.companyService.apiGetCompanyAssignedAPs(this.companyId, this.search, this.pageMyAP).subscribe((result: ApiResponse) => {
          if (result.status) {
            if (this.pageMyAP === 1) {
              this.myAP = result.data.data;
              this.pageMyAP++;
            } else {
              if(result.data.data.length === 0){
                this.maxAPLoaded = true;
              }else{
                result.data.data.forEach(m => {
                  this.myAP.push(m);
                });
                this.pageMyAP++;
              }

            }

          }
          this.loading = false;
          this.myAPResponseFlag = false;
        });
      } else {
        this.userService.apListForTeam(this.teamId, this.search, this.pageMyAP).subscribe((result: ApiResponse) => {
          if (result.status) {
            if (this.pageMyAP === 1) {
              this.myAP = result.data.data;
              this.pageMyAP++;
            } else {
              if(result.data.data.length === 0){
                this.maxAPLoaded = true;
              }else{
                result.data.data.forEach(m => {
                  this.myAP.push(m);
                });
                this.pageMyAP++;
              }
            }
          }
          this.loading = false;
          this.myAPResponseFlag = false;
        });
      }
    }
  }

  getSearch() {
    this.pageMyAP = 1;
    this.maxAPLoaded = false;
    if (this.search.toString() !== '') {
      this.searchEnabled = true;
      if (this.myAPResponseFlag === false) {
        this.myAPResponseFlag = true;
        if (this.onlyCompany === 'yes') {
          this.companyService.apiGetCompanyAssignedAPs(this.companyId, this.search, this.pageMyAP).subscribe((result: ApiResponse) => {
            if (result.status) {
              this.myAP = result.data.data;
            }
            this.myAPResponseFlag = false;
          });
        } else {
          this.userService.apListForTeam(this.teamId, this.search, this.pageMyAP).subscribe((result: ApiResponse) => {
            if (result.status) {
              this.myAP = result.data.data;
            }
            this.myAPResponseFlag = false;
          });
        }
      }
    } else {
      this.searchEnabled = false;
      this.loadMyActionPoints();
    }
  }

  loadSearch() {
    this.loading = true;
    this.pageMyAP++;
    if (this.onlyCompany === 'yes') {
      this.companyService.apiGetCompanyAssignedAPs(this.companyId, this.search, this.pageMyAP).subscribe((result: ApiResponse) => {
        this.loading = false;
        if (result.status) {
          result.data.data.forEach(d => {
            this.myAP.push(d);
          });
        }
      });
    } else {
      this.userService.apListForTeam(this.teamId, this.search, this.pageMyAP).subscribe((result: ApiResponse) => {
        this.loading = false;
        if (result.status) {
          result.data.data.forEach(d => {
            this.myAP.push(d);
          });
        }
      });
    }
  }

  public async closeModal() {
    await this.modalCtrl.dismiss(null, 'closed');
  }
}
